/**
 * Post-trip closure helpers for riders who must complete or explicitly skip tip/rating.
 */

export function needsPostTripClosurePrompt(booking) {
  if (!booking) return false;
  if (booking.status === "PAID") return true;
  if (
    booking.status === "REACHED" &&
    (booking.prepaid || booking.booking_from_web)
  ) {
    return true;
  }
  return false;
}

export function findPendingClosureBooking(activeBookings) {
  if (!activeBookings || !activeBookings.length) return null;
  return activeBookings.find((b) => needsPostTripClosurePrompt(b)) || null;
}

export function buildCompleteWithoutTipPayload(booking, { rating } = {}) {
  return {
    ...booking,
    rating: typeof rating === "number" ? rating : 0,
    feedback: booking.feedback || "",
    status: "COMPLETE",
    tipamount: null,
  };
}

export function completeBookingWithoutTip(
  dispatch,
  updateBooking,
  booking,
  options = {},
) {
  const payload = buildCompleteWithoutTipPayload(booking, options);
  dispatch(updateBooking(payload));
  return payload;
}
